<template>
  <v-card class="px-10 py-5">
    <TreatmentDialog
      :visible="dialog"
      :item="editedItem"
      @save="save"
      @close="close"
    />
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >¿Seguro que quieres eliminar el tratamiento?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete"
            >Cancelar</v-btn
          >
          <v-btn color="red darken-1" text @click="deleteItemConfirm"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-btn
        @click="$router.push({ name: 'Pacientes' })"
        class="mx-2"
        fab
        dark
        small
        color="primary"
      >
        <v-icon dark>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      {{ patientData.Nombre }} {{ patientData.Apellido }}
      <v-spacer></v-spacer>
      <v-col cols="12" md="3" sm="12">
        <v-btn @click="newItem" color="blue-grey" class="ma-2 white--text">
          Nuevo Tratamiento
          <v-icon right dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-col>
    </v-card-title>
    <v-data-table
      :headers="selectedHeaders"
      :items="treatments"
      :options.sync="options"
      multi-sort
      :server-items-length="totalTreatments"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.Finalizado="{ item }">
        <v-icon :color="(item.Finalizado && 'green') || 'red'">{{
          `mdi-${(item.Finalizado && "check") || "close"}`
        }}</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small class="mr-2" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from "@/utils/axios.js";
import TreatmentDialog from "@/components/TreatmentDialog.vue";

export default {
  components: { TreatmentDialog },
  props: ["patientId"],
  data() {
    return {
      patientData: {},
      totalTreatments: 0,
      treatments: [],
      loading: true,
      activeFilter: "Causa_de_la_cita",
      options: {},
      editedIndex: -1,
      dialog: false,
      dialogDelete: false,
      editedItem: {
        id: null,
        Causa_de_la_cita: null,
        Descripcion: `

        `,
        frontPoints: [],
        backPoints: [],
        sidePoints: [],
        Escala_descriptiva_intesidad_dolor: null,
        Escala_numerica_dolor: 5,
        Escala_analogos_visual: 5,
        Visitas: [],
        Finalizado: null,
      },
      selectedFields: ["Causa de la cita", "Finalizado", "Acciones"],
      headers: [
        {
          text: "Causa de la cita",
          align: "start",
          sortable: true,
          value: "Causa_de_la_cita",
          display: "text",
        },
        {
          text: "Finalizado",
          sortable: true,
          value: "Finalizado",
          display: "boolean",
        },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    searchableFields() {
      return this.selectedHeaders.filter((h) => h.searchable);
    },
    allFields() {
      return this.headers.map((h) => h.text);
    },
    selectedHeaders() {
      return this.headers.filter((h) => {
        return this.selectedFields.includes(h.text);
      });
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  mounted() {
    axios.get(`/pacientes/${this.patientId}`).then((res) => {
      this.patientData = res.data;
    });
  },
  methods: {
    newItem() {
      this.editedItem = Object.assign(
        {},
        {
          id: null,
          Causa_de_la_cita: null,
          Descripcion: `
          `,
          Escala_descriptiva_intesidad_dolor: null,
          Escala_numerica_dolor: 5,
          frontPoints: [],
          backPoints: [],
          sidePoints: [],
          Escala_analogos_visual: 5,
          Visitas: [],
          Finalizado: null,
          paciente: this.patientId,
        }
      );
      this.dialog = true;
    },
    editItem(item) {
      console.log(item);
      this.editedIndex = this.treatments.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.treatments.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      let self = this;
      axios
        .delete(`/tratamientos/${this.editedItem.id}`)
        .then(() => {
          self.$alertify.success("Tratamiento eliminado");
        })
        .catch(() => {
          self.$alertify.error("Ha ocurrido un error");
        })
        .then(() => {
          self.closeDelete();
          self.getDataFromApi();
        });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save(data) {
      let self = this;
      if (this.editedItem.id) {
        axios
          .put(`/tratamientos/${this.editedItem.id}`, data)
          .then(() => {
            self.$alertify.success("Tratamiento actualizado");
          })
          .catch(() => {
            self.$alertify.error("Ha ocurrido un error");
          })
          .then(() => {
            self.close();
            self.getDataFromApi();
          });
      } else {
        delete data.id;
        axios
          .post(`/tratamientos`, data)
          .then(() => {
            self.$alertify.success("Tratamiento creado");
          })
          .catch(() => {
            self.$alertify.error("Ha ocurrido un error");
          })
          .then(() => {
            self.close();
            self.getDataFromApi();
          });
      }
    },
    getDataFromApi() {
      let self = this;
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const _sort = sortBy
        .map(function(e, i) {
          return `${e}:${(sortDesc[i] && "DESC") || "ASC"}`;
        })
        .join(",");
      const qs = require("qs");

      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
      };

      if (sortBy.length > 0) {
        params._sort = _sort;
      }

      const query = qs.stringify(params, {
        encodeValuesOnly: true,
      });

      axios
        .get(`/tratamientos?paciente=${self.patientId}&${query}`)
        .then((res) => {
          self.treatments = res.data;
          axios
            .get(`/tratamientos/count?paciente=${self.patientId}&${query}`)
            .then((resCount) => {
              self.totalTreatments = resCount.data;
              self.loading = false;
            });
        });
    },
  },
};
</script>
<style lang="scss"></style>
